import axiosInstance from "../../services/axiosInstance";
import { registerUserActions } from "../backendRoutes";
import { removeUserSessionHelper } from "../userSessionDetailsHelper/saveUserSessionHelper";

export const logoutHelper = () => {
  axiosInstance.delete("logout").then().catch().then(removeUserSessionHelper);
};
